import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-uploader-file',
    templateUrl: './uploader-file.component.html',
    styleUrls: ['./uploader-file.component.scss'],
    standalone: false
})
export class UploaderFileComponent {

  files: any[] = [];

  @Input() isMultiple: boolean = false
  @Input() accept: string = ''
  @Output() filesChange: EventEmitter<any[]> = new EventEmitter<any[]>()
  @Output() invalidFilesChange: EventEmitter<File[]> = new EventEmitter<File[]>()

  /**
   * on file drop handler
   */
  onFileDropped(event:any) {
    const files = Array.from<File>(event ?? []);
    this.prepareFilesList(this.isMultiple ? files : files.slice(0, 1));
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event:any) {
    const files = Array.from<File>(event?.target?.files ?? []);
    this.prepareFilesList(this.isMultiple ? files : files.slice(0, 1));
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.filesChange.emit(this.files);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<File>) {
    const validFiles = this.filterAcceptedFiles(files);
    const invalidFiles = files.filter(file => !validFiles.includes(file));

    if (invalidFiles.length > 0) {
      this.invalidFilesChange.emit(invalidFiles);
    }

    if (!this.isMultiple) {
      this.files = validFiles.length > 0 ? [validFiles[0]] : [];
      this.filesChange.emit(this.files);
      return;
    }

    for (const item of validFiles) {
      this.files.push(item);
    }
    this.filesChange.emit(this.files);
  }

  private filterAcceptedFiles(files: Array<File>): Array<File> {
    if (!this.accept?.trim()) {
      return [...files];
    }

    const acceptedExtensions = this.accept
      .split(',')
      .map(value => value.trim().toLowerCase())
      .filter(value => value.startsWith('.'));

    if (acceptedExtensions.length === 0) {
      return [...files];
    }

    return files.filter(file =>
      acceptedExtensions.some(extension => file.name.toLowerCase().endsWith(extension))
    );
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes:any, decimals:any) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
